<div class="modal-body justify-content-center">
  <div class="cm-header-section">
    <h5 class="modal-title" id="productionCompanyModalLabel">{{constants.modalTitle}}</h5>
    <button (click)="closeModal()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
      <span class="cm-close-text">{{constants.close}}</span>
    </button>
  </div>

  <div class="si-container">
    <app-studio-inquiry-sidebar [activeStep]="1"></app-studio-inquiry-sidebar>

    <form class="si-application" [formGroup]="companyForm" (ngSubmit)="onNext()">
      <div class="si-section">
        <h2 class="si-section-title">{{constants.companyNameSection}}<span class="star-red">*</span></h2>
        <div class="custom-floating-label si-field">
          <input type="text" class="form-control" id="companyName" formControlName="companyName" maxlength="50" />
          <label for="companyName" class="form-label">{{constants.companyName}}</label>
        </div>
      </div>

      <div class="si-section">
        <h2 class="si-section-title">{{constants.contactSection}}<span class="star-red">*</span></h2>
        <div class="si-pc-contact-grid">
          <div class="custom-floating-label si-field" *ngFor="let field of constants.contactFields">
            <input type="text" class="form-control" [id]="field.id" [formControlName]="field.id"
              [placeholder]="field.label" maxlength="80" />
            <label [for]="field.id" class="form-label">{{field.label}}</label>
          </div>
        </div>
      </div>

      <div class="si-section">
        <h2 class="si-section-title">{{constants.addressSection}}</h2>
        <div class="si-pc-address">
          <div class="custom-dropdown custom-floating-label si-field">
            <label for="country" class="form-label">{{constants.country}}</label>
            <select id="country" class="custom-select" formControlName="country" (change)="onCountryChange($event)">
              <option class="dropdown-option" value="" disabled selected hidden>{{constants.selectCountry}}</option>
              <option class="dropdown-option" *ngFor="let country of countries" [value]="country.countryId">
                {{country.countryName}}
              </option>
            </select>
          </div>

          <div class="si-pc-address-grid">
            <div class="custom-floating-label si-field si-pc-street">
              <input type="text" class="form-control" id="street" formControlName="street"
                [placeholder]="constants.street" maxlength="85" />
              <label for="street" class="form-label">{{constants.street}}</label>
            </div>

            <div class="custom-floating-label si-field">
              <input type="text" class="form-control" id="city" formControlName="city" [placeholder]="constants.city"
                maxlength="50" />
              <label for="city" class="form-label">{{constants.city}}</label>
            </div>

            <div class="custom-dropdown custom-floating-label si-field">
              <label for="state" class="form-label">{{constants.state}}</label>
              <select id="state" class="custom-select" formControlName="state">
                <option class="dropdown-option" value="" disabled selected hidden>{{constants.selectState}}</option>
                <option class="dropdown-option" *ngFor="let state of states" [value]="state.stateName">
                  {{state.stateName}}
                </option>
              </select>
            </div>

            <div class="custom-floating-label si-field">
              <input type="text" class="form-control" id="zipCode" formControlName="zipCode"
                [placeholder]="constants.zipCodePlaceholder" maxlength="12" />
              <label for="zipCode" class="form-label">{{constants.zipCode}}</label>
            </div>

            <div class="custom-floating-label si-field si-pc-address-phone">
              <input type="text" class="form-control" id="addressPhone" formControlName="addressPhone"
                [placeholder]="constants.addressPhone" maxlength="20" />
              <label for="addressPhone" class="form-label">{{constants.addressPhone}}</label>
            </div>
          </div>

          <div class="common-checkbox-button si-pc-checkbox">
            <input type="checkbox" id="billingDifferent" class="common-checkbox-input"
              formControlName="billingDifferent" />
            <label class="common-checkbox-label si-pc-checkbox-label" for="billingDifferent">
              {{constants.billingDifferent}}
            </label>
          </div>
        </div>
      </div>

      <div class="si-section">
        <h2 class="si-section-title">{{constants.contactMethodSection}}</h2>
        <div class="si-pc-contact-methods">
          <div class="common-radio-btn" *ngFor="let method of constants.contactMethods; let i = index">
            <input class="common-radio-input mb-0" type="radio" name="preferredContact"
              formControlName="preferredContact" [id]="'preferredContact-' + i" [value]="method" />
            <label class="common-radio-label" [for]="'preferredContact-' + i">{{method}}</label>
          </div>
        </div>
      </div>

      <div class="si-buttons">
        <div class="si-back">
          <img src="../assets/images/blue-left-icon.svg" alt="" class="si-back-icon">
          <a class="text-link si-back-link" tabindex="0" (click)="onBack()" (keydown.enter)="onBack()"
            (keydown.space)="onBack()">{{constants.back}}</a>
        </div>
        <button type="submit" class="btn common-btn-secondary"
          [disabled]="companyForm.invalid">{{constants.next}}</button>
      </div>
    </form>
  </div>
</div>
